export enum ChecklistStatus {
  NotStarted = 0,
  InProgress = 1,
  Done = 2
}

export type ChecklistSubtask = {
  text: string;
  checked: boolean;
};

export type ChecklistItem = {
  id: number;
  installationId: number;
  stepNumber: number;
  stepTitle: string;
  status: number;
  comments: string;
  assigneeId: number | null;
  doneAt: string | null;
  subtasks: string | null;
  createdAt: string;
  updatedAt: string;
};

export const CHECKLIST_ENABLED_PRODUCTS: ReadonlySet<number> = new Set([2, 5]);

export const UPLOADABLE_SUBTASK_KEYS: ReadonlySet<string> = new Set([
  'checklistStep8Sub1',
  'checklistStep10Sub1',
  'checklistStep10Sub2'
]);

export type ChecklistSummary = {
  installationId: number;
  done: number;
  total: number;
};

export function parseSubtasks(raw: string | null | undefined): ChecklistSubtask[] {
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((x) => x && typeof x.text === 'string')
      .map((x) => ({ text: String(x.text), checked: Boolean(x.checked) }));
  } catch {
    return [];
  }
}

export function serializeSubtasks(subtasks: ChecklistSubtask[]): string {
  return JSON.stringify(subtasks);
}
